// Help text under the items list. This is the signed-in user's first
// explanation of what the product is, so it carries the same order of billing
// as the landing page: the boat leads, and everything else is named in the
// same breath rather than relegated to a footnote.
//
// It is rendered unconditionally (not only on an empty list), so it has to stay
// true for someone whose fleet is a house and two cars.

import { PrimaryText, Ruler } from '../components';
import { PRODUCT_NAME } from '../fleet-shared/Brand.mjs';

export const ItemsHelp = () => (
  <PrimaryText>
    <div>
      An <b>Item</b> is the thing you're looking after — most often a <b>Boat</b>,
      though a <b>House</b>, <b>Car</b>, <b>Airplane</b>, or <b>Project</b> works
      exactly the same way.
    </div>

    <Ruler/>

    <div>An <b>Item</b> has <b><u>Tasks</u></b> you can track. For example:</div>

    <div><b>Boats</b> need an <b><u>Oil Change</u></b> at some engine-hour reading, or <b><u>Bottom Paint</u></b> on some date.</div>
    <div><b>Cars</b> have <b><u>Oil Changes</u></b> or <b><u>Brakes</u></b> due at some mileage.</div>
    <div><b>Houses</b> need <b><u>Smoke Detector Batteries</u></b> changed on some date.</div>

    <Ruler/>

    <div>Plan a <b><u>Trip</u></b> leg by leg and {PRODUCT_NAME} draws the route, measures the distance, and brings you the marine weather, tides and currents along it.</div>

    <Ruler/>

    <div>{PRODUCT_NAME} keeps a <b>Logbook</b> so you can track what you've done. For example:</div>

    <div>a <b>Captain's Log</b> for a boat's passages, a <b>Pilot's Logbook</b> for an airplane's flights, and a <b>Maintenance Log</b> for the work on any of them — so you can see when you last changed the oil, or where you were this time last summer.</div>
    <Ruler/>
  </PrimaryText>
);
